module.exports = __webpack_public_path__ + "img/202306_09.67ac5b18.jpg";